import React from "react";
import { getIsoToMediumFormatDatetime } from "../../../../util/common";

function formatStatus(status) {
  if (!status) return "--";
  return status
    .toString()
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/^\w|\s\w/g, match => match.toUpperCase());
}

function formatDateTime(isoDateTime) {
  if (!isoDateTime) return "--";
  try {
    return getIsoToMediumFormatDatetime(isoDateTime);
  } catch (error) {
    return "--";
  }
}

export default function SingleOrder({ order }) {
  if (!order) return null;

  const {
    id,
    kitId,
    productName,
    fulfillmentStatus,
    outboundTrackingUrl,
    inboundTrackingUrl,
    vendor,
    clinicianName,
    createdAt
  } = order || {};

  return (
    <>
      <style>
        {`
        .orderCard {
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(30,40,60,0.10);
          padding: 2rem 1.5rem;
          margin-bottom: 1.5rem;
          transition: box-shadow 0.2s, transform 0.2s;
        }
        .orderCard:hover {
          box-shadow: 0 6px 20px rgba(30,40,60,0.14);
          transform: translateY(-2px);
        }
        .orderGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 1.5rem;
        }
        .orderField {
          display: flex;
          flex-direction: column;
          margin-bottom: 0.2rem;
        }
        .orderLabel {
          font-size: 0.82rem;
          color: #888;
          margin-bottom: 0.25rem;
          font-weight: 500;
          letter-spacing: 0.01em;
        }
        .orderValue {
          font-size: 1.08rem;
          font-weight: 600;
          color: #222;
          margin: 0;
        }
        .orderTrackingLink {
          color: #1da86b;
          font-weight: 600;
          text-decoration: underline dotted;
          transition: color 0.15s, text-decoration 0.15s;
        }
        .orderTrackingLink:hover {
          color: #168e58;
          text-decoration: underline solid;
        }
        `}
      </style>
      <div className="orderCard">
        <div className="orderGrid">
          <div className="orderField">
            <span className="orderLabel">Order ID</span>
            <span className="orderValue">{id ?? "--"}</span>
          </div>
          <div className="orderField">
            <span className="orderLabel">Product</span>
            <span className="orderValue">{productName ?? "--"}</span>
          </div>
          <div className="orderField">
            <span className="orderLabel">Status</span>
            <span className="orderValue">{formatStatus(fulfillmentStatus)}</span>
          </div>
          <div className="orderField">
            <span className="orderLabel">Created</span>
            <span className="orderValue">{formatDateTime(createdAt)}</span>
          </div>
          <div className="orderField">
            <span className="orderLabel">Kit ID</span>
            <span className="orderValue">{kitId ?? "--"}</span>
          </div>
          <div className="orderField">
            <span className="orderLabel">Ordered by</span>
            <span className="orderValue">{clinicianName ?? "--"}</span>
          </div>
          <div className="orderField">
            <span className="orderLabel">Vendor</span>
            <span className="orderValue">{vendor ?? "--"}</span>
          </div>
          <div className="orderField">
            <span className="orderLabel">Outbound Tracking</span>
            {outboundTrackingUrl ? (
              <a
                href={outboundTrackingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="orderTrackingLink"
              >
                View Tracking
              </a>
            ) : (
              <span className="orderValue">--</span>
            )}
          </div>
          <div className="orderField">
            <span className="orderLabel">Inbound Tracking</span>
            {inboundTrackingUrl ? (
              <a
                href={inboundTrackingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="orderTrackingLink"
              >
                View Tracking
              </a>
            ) : (
              <span className="orderValue">--</span>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
